import { Component, OnInit } from '@angular/core';
import { DialogRef } from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-kendo-message-dialog',
  templateUrl: './kendo-message-dialog.component.html',
  styleUrls: ['./kendo-message-dialog.component.scss']
})
export class KendoMessageDialogComponent implements OnInit {
  title: string;
  message: string;
  messages: Array<string>;
  confirmed: boolean = false;

  constructor(private dialog: DialogRef) {
  }

  ngOnInit() {
  }

  close() {
    this.confirmed = true;
    this.dialog.close();
  }
}
